
export class BankIdReq{
    id:number

    constructor(id:any){
        this.id = id
    }
}